import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/phoneIcon.png';
import _imports_1 from '../assets/sendEmailIcon.png';
import _imports_2 from '../assets/collection_icon.png';
import _imports_3 from '../assets/share_icon.png';
import _imports_4 from '../assets/setting_icon.png';
import _imports_5 from '../assets/warn_icon.png';
const _withScopeId = n => (_pushScopeId("data-v-759c29fb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 0,
  class: "main-container"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "common-bg"
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "common-bg"
};
const _hoisted_8 = {
  key: 2
};
const _hoisted_9 = {
  class: "common-bg"
};
const _hoisted_10 = {
  key: 3
};
const _hoisted_11 = ["onClick", "alt"];
const _hoisted_12 = {
  key: 4
};
const _hoisted_13 = {
  class: "common-bg"
};
const _hoisted_14 = {
  class: "six-img-area"
};
const _hoisted_15 = ["height", "width", "alt", "onClick"];
const _hoisted_16 = {
  key: 5
};
const _hoisted_17 = {
  class: "common-bg"
};
const _hoisted_18 = {
  class: "contact-area"
};
const _hoisted_19 = {
  class: "contact-info-title"
};
const _hoisted_20 = {
  class: "contact-info-subtitle"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon-bg",
  alt: "电话"
}, null, -1));
const _hoisted_23 = ["onClick"];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "icon-bg",
  alt: "邮箱"
}, null, -1));
const _hoisted_25 = {
  key: 6
};
const _hoisted_26 = {
  class: "common-bg"
};
const _hoisted_27 = {
  class: "contact-area"
};
const _hoisted_28 = {
  class: "contact-info-title"
};
const _hoisted_29 = {
  class: "contact-info-subtitle"
};
const _hoisted_30 = {
  key: 0
};
const _hoisted_31 = {
  class: "count-down-info-show"
};
const _hoisted_32 = {
  class: "count-down-days"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "count-down-unit"
}, " 天", -1));
const _hoisted_34 = {
  key: 0,
  class: "bottom-setting-container"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "bottom-setting-button-image"
}, null, -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "bottom-setting-button-text"
}, "收藏", -1));
const _hoisted_37 = [_hoisted_35, _hoisted_36];
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "bottom-setting-button-image"
}, null, -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "bottom-setting-button-text"
}, "转发", -1));
const _hoisted_40 = [_hoisted_38, _hoisted_39];
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "bottom-setting-button-image"
}, null, -1));
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "bottom-setting-button-text"
}, "管理", -1));
const _hoisted_43 = [_hoisted_41, _hoisted_42];
const _hoisted_44 = {
  key: 3,
  class: "bottom-setting-separator"
};
const _hoisted_45 = {
  key: 1,
  class: "bottom-hint-style"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "内容由用户制作，请注意识别真伪，避免被骗", -1));
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "App会员可去除本页广告及底部标识", -1));
const _hoisted_48 = {
  key: 2,
  class: "report-area"
};
const _hoisted_49 = {
  key: 1,
  class: "input-pwd-area"
};
const _hoisted_50 = {
  class: "input-pwd"
};
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "15px",
    "font-weight": "bold",
    "padding-top": "30px",
    "padding-left": "15px",
    "padding-right": "15px"
  }
}, " 您是扫码者，可进行以下操作 ", -1));
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  width: "24px",
  height: "24px"
}, null, -1));
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "manage-warn-text"
}, "投诉", -1));
const _hoisted_54 = [_hoisted_52, _hoisted_53];
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "background-color": "#EDEDED",
    "height": "1px",
    "margin-left": "10px",
    "margin-right": "10px"
  }
}, null, -1));
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "13px",
    "padding-left": "15px",
    "padding-right": "15px",
    "color": "#576B95",
    "text-align": "left",
    "margin-top": "20px"
  }
}, " 活码的创建者，可点击 “二维码和条形码生成器App” 的【历史】功能，查看此活码的扫码量等相关统计数据。 ", -1));
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "25px",
    "color": "white",
    "text-align": "left",
    "-webkit-user-select": "none",
    "-moz-user-select": "none",
    "-ms-user-select": "none",
    "user-select": "none"
  }
}, [/*#__PURE__*/_createTextVNode(" 点击右上角的「"), /*#__PURE__*/_createElementVNode("span", {
  class: "bottom-setting-guide-highlight-text-dot"
}, "···"), /*#__PURE__*/_createTextVNode("」，"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("并选择「"), /*#__PURE__*/_createElementVNode("span", {
  class: "bottom-setting-guide-highlight-text"
}, "收藏"), /*#__PURE__*/_createTextVNode("」。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "13px",
    "line-height": "1.6"
  }
}, [/*#__PURE__*/_createTextVNode(" - 微信在「"), /*#__PURE__*/_createElementVNode("span", {
  class: "bottom-setting-guide-highlight-text"
}, "我-收藏"), /*#__PURE__*/_createTextVNode("」查看该活码；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" - 支付宝在「"), /*#__PURE__*/_createElementVNode("span", {
  class: "bottom-setting-guide-highlight-text"
}, "我的小程序-我的收藏"), /*#__PURE__*/_createTextVNode("」里查看；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" - QQ在「"), /*#__PURE__*/_createElementVNode("span", {
  class: "bottom-setting-guide-highlight-text"
}, "我的收藏"), /*#__PURE__*/_createTextVNode("」里查看； ")])], -1));
const _hoisted_58 = {
  class: "mock-ad-wrapper"
};
const _hoisted_59 = {
  class: "ad-close-area"
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "white",
    "font-size": "13px"
  }
}, "*App会员可去除本页所有广告及标识", -1));
const _hoisted_61 = {
  class: "mock-ad"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ad-logo-container"
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "background-color": "#2E2638",
    "color": "white",
    "padding": "3px 5px",
    "border-radius": "3px"
  }
}, "广告")], -1));
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ad-top-des-area"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "icon.png",
  width: "80px",
  height: "80px",
  alt: "应用图标"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "ad-des-column"
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "18px",
    "font-weight": "bold",
    "color": "white",
    "text-align": "left"
  }
}, "二维码和条形码生成器App"), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "white",
    "margin-top": "10px",
    "font-size": "15px",
    "text-align": "left"
  }
}, "各大手机应用市场均有下载！")])], -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-left": "15px",
    "margin-right": "15px",
    "margin-top": "5vh"
  }
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "white",
    "font-size": "16px"
  }
}, "快速扫码、制作二维码和条形码;")]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-top": "1vh"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "white",
    "font-size": "16px"
  }
}, "支持连续扫码、批量制码；")]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-top": "1vh"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "white",
    "font-size": "16px"
  }
}, "操作简单，相当好用！")])], -1));
import { useRoute } from "vue-router";
import axios from "axios";
import { onMounted, ref, watch } from "vue";
import { showDialog, showImagePreview, showSuccessToast, showToast } from "vant";
import { Base64 } from 'js-base64';
import useClipboard from 'vue-clipboard3';
import { router } from "@/utils/RouterUtil";
const collectionButton = 1000; //收藏按钮
const shareButton = 1001; //转发按钮
const manageButton = 1002; //管理按钮
const bottomButtonSep = 1003; //分隔符

export default {
  __name: 'LiveCodeShowComponents',
  setup(__props) {
    const route = useRoute();
    const liveCodeId = route.params.liveCodeId;
    const bodyList = ref([]);
    let createdByVip = false;
    const showContent = ref(false);
    const showMockAd = ref(false);
    const querying = ref(true);
    const inputPwd = ref('');
    const errorInfo = ref('');
    const showKeyboard = ref(true);
    const showManage = ref(false); //兼容老版本，默认为false，是否展示管理按钮
    const showBottomSetting = ref(false); //是否显示底部的设置区域
    const bottomSettingButtons = ref([]);
    const showManageContentDialog = ref(false); //是否展示管理弹窗
    const showCollectionGuide = ref(false); //是否展示收藏引导
    const {
      toClipboard
    } = useClipboard();
    watch(inputPwd, newVal => {
      if (newVal.length === 4) {
        querying.value = true;
        requestContent(newVal);
      }
    });
    onMounted(() => {
      document.title = '\u200b';
    });
    const copy = async val => {
      try {
        await toClipboard(val);
        console.log('复制成功!');
      } catch (e) {
        console.log(e);
      }
    };
    const dismissMockAd = () => {
      showMockAd.value = false;
    };
    const goSearchApp = () => {
      try {
        // navigator.clipboard.writeText('二维码和条形码生成器');
        copy('二维码和条形码生成器');
        showSuccessToast('复制完成');
      } catch (error) {
        console.log(error);
      } finally {
        dismissMockAd();
      }
    };
    function imageOnClick(urls, index) {
      console.log('image onclick index = ' + index);
      showImagePreview({
        images: urls.map(url => url.replace('http://hm.huichangliang.com', 'https://image.video.huichangliang.com')),
        onClose() {
          window.history.back();
        },
        closeable: true,
        startPosition: index,
        loop: false
      });
      window.history.pushState(null, null, document.URL);
    }
    const goDownloadApp = () => {
      try {
        // navigator.clipboard.writeText('二维码和条形码生成器');
        copy('二维码和条形码生成器');
      } catch (error) {
        console.log(error);
      }
      showDialog({
        title: "制作步骤",
        message: "<div style='text-align: left;'>1、打开手机应用市场，搜索“二维码和条形码生成器”并下载安装。下载时请认准下面的图标：</div>" + "<img src=\"icon.png\" width=\"100px\" height=\"100px\" alt=\"应用图标\"/>" + "<div style='text-align: left;margin-top: 5px;'>2、安装完成后，点击App首页的【创建活码】即可创建同款二维码。</div>" + "<div style='text-align: left;color: #42b983; margin-top: 10px;'>*应用名已经复制，直接粘贴到应用市场搜索框即可。</div>",
        allowHtml: true,
        confirmButtonText: "我知道了"
      }).then(() => {
        window.history.back();
      });
      window.history.pushState(null, null, document.URL);
    };
    const callPhone = phone => {
      phone = phone.replaceAll(/\)\s+/g, '');
      phone = phone.replaceAll(/[-()（）]/g, '');
      const realPhone = phone.match(/(\d{3,20})/g);
      if (realPhone) {
        window.location.href = `tel:${realPhone[0]}`;
      }
    };
    const sendEmail = email => {
      const realEmail = email.match(/[A-Za-z0-9.\-+_]+@[A-Za-z0-9.\-+_]+\.[A-Za-z]+/g);
      copy(realEmail[0]);
      showSuccessToast('邮箱地址复制成功');

      // if (realEmail) {
      //     showDialog({
      //         title: '请复制邮箱地址',
      //         message: realEmail,
      //         confirmButtonText: '复制',
      //         cancelButtonText: '取消',
      //         showCancelButton: true,
      //     }).then(() => {
      //         window.history.back();
      //         // window.location.href = `mailto:${realEmail[0]}`;
      //         copy(realEmail[0]);
      //         showSuccessToast('复制成功');
      //     }).catch(() => {
      //         window.history.back();
      //     });
      //     window.history.pushState(null, null, document.URL);
      // }
    };
    const collectionButtonOnClicked = () => {
      showCollectionGuide.value = true;
    };
    const dismissCollectionGuide = () => {
      showCollectionGuide.value = false;
    };
    const shareButtonOnClicked = () => {
      showToast('点击右上角「···」，进行分享');
    };
    const manageButtonOnClicked = () => {
      showManageContentDialog.value = true;
    };
    const computeSixImageSize = () => {
      const screenWidth = window.innerWidth;
      return screenWidth * 0.28;
    };
    const reformatImageUrl = url => {
      const hmUrl = url.replace('xxx.huichangliang.com', 'hm.huichangliang.com');
      const newUrl = hmUrl.replace('hm.huichangliang.com', 'image.video.huichangliang.com');
      const finalUrl = newUrl.replace('http://', 'https://');
      return finalUrl;
    };
    const report = () => {
      // https://introduce.huichangliang.com/#/complaint?complaintId=123
      router.push('/complaint?complaintId=' + liveCodeId);
    };
    const fromManageReport = () => {
      showManageContentDialog.value = false;
      report();
    };
    const showCountDownDays = endTimeStr => {
      let endDate = Date.parse(endTimeStr);
      let nowDate = new Date(new Date().setHours(0, 0, 0, 0));
      let dateSpan = endDate - nowDate;
      let inDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      if (inDays < 0) {
        inDays = 0;
      }
      return inDays;
    };
    const createTitleStyle = style => {
      let fontSize = style['fontSize'];
      let alignment = style['alignment'];
      let color = Number(style['color']).toString(16).substring(2); //10进制颜色转换成16进制颜色
      return `font-size:${fontSize}px;text-align:${alignment};font-weight: bold;color:#${color};line-height: 1.5;white-space: pre-wrap;word-break:break-all;`;
    };
    const createOneImageContainerStyle = imgTxt => {
      let isFillWidth = imgTxt['fillWidth'];
      if (isFillWidth === true) {
        return '';
      }
      return 'margin-top: 10px;margin-left: 15px;margin-right: 15px;margin-bottom:10px;';
    };
    const createOneImageStyle = imgTxt => {
      let isFillWidth = imgTxt['fillWidth'];
      if (isFillWidth === true) {
        return 'width: 100%;';
      } else {
        return 'border-radius: 5px;max-width: 100%;';
      }
    };
    const createNormalBodyStyle = style => {
      let fontSize = style['fontSize'];
      let alignment = style['alignment'];
      let color = Number(style['color']).toString(16).substring(2); //10进制颜色转换成16进制颜色
      let boldType = 'bold';
      if (style['bold'] === false) {
        boldType = 'normal';
      }
      return `font-size:${fontSize + 1}px;text-align:${alignment};font-weight: ${boldType};color:#${color};line-height: 1.5;white-space: pre-wrap;word-break:break-all;`;
    };
    const createCbBodyStyle = style => {
      let backgroundColor = Number(style['backgroundColor']).toString(16).substring(2); //10进制颜色转换成16进制颜色
      return `background-color:#${backgroundColor};padding-top:15px;padding-bottom:15px;padding-left:15px;padding-right:15px;border-radius:10px;`;
    };
    requestContent('');
    function requestContent(pwd) {
      axios({
        baseURL: 'https://server.huichangliang.com',
        url: `/livecode/getById?liveCodeId=${liveCodeId}&pwd=` + pwd
      }).then(s => {
        // console.log("ssss", s)
        const {
          status,
          data
        } = s;
        if (status === 200 && data) {
          if (data.code === 1) {
            querying.value = false;
            //需要展示输入密码框
            showContent.value = false;
          } else if (data.code === 2) {
            //密码不对
            querying.value = false;
            showContent.value = false;
            errorInfo.value = '密码错误';
          } else if (data.code === 3) {
            //扫码次数超了
            showDialog({
              title: '扫码失败',
              allowHtml: true,
              message: "<div style='text-align: center;font-size: 16px;margin-top: 15px;'>扫码的次数超限！</div>" + "<div style='text-align: left;color: #42b983; margin-top: 20px;font-size: 12px;'>*如果这是您创建的活码，可在App里修改扫码次数。</div>",
              confirmButtonText: '我知道了'
            });
          } else if (data.code === 4) {
            //活码被删除
            showDialog({
              title: '扫码失败',
              allowHtml: true,
              message: "<div style='text-align: center;font-size: 16px;margin-top: 15px;'>内容不存在！</div>" + "<div style='text-align: left;font-size: 13px;margin-top: 15px;'>可能的原因：\n1、用户删除了此活码；\n2、内容涉嫌违规被系统自动删除；\n</div>",
              confirmButtonText: '我知道了'
            });
          } else if (data.code === 5) {
            //活码过期了
            showDialog({
              title: '扫码失败',
              allowHtml: true,
              message: "<div style='text-align: center;font-size: 16px;margin-top: 15px;'>活码已过期，禁止访问！</div>" + "<div style='text-align: left;color: #42b983; margin-top: 20px;font-size: 12px;'>*如果这是您创建的活码，可在App里修改活码有效期。</div>",
              confirmButtonText: '我知道了'
            });
          } else if (data.code === 1000) {
            //正常数据
            querying.value = false;
            showContent.value = true;
            createdByVip = data.result.createUserVipType !== 0;
            showMockAd.value = !createdByVip;
            const parsedData = JSON.parse(data.result.content);
            bodyList.value = parsedData.styleList;

            //兼容老版本，老版本创建的活码不包含bottomSetting属性
            const showCollection = parsedData.bottomSetting?.showCollection ?? false;
            const showShare = parsedData.bottomSetting?.showShare ?? false;
            showManage.value = parsedData.bottomSetting?.showManage ?? false;
            // console.log('showCollection = ' + showCollection + ' showShare = ' + showShare + ' showManage = ' + showManage.value);
            if (showCollection) {
              bottomSettingButtons.value.push(collectionButton);
            }
            if (showShare) {
              if (bottomSettingButtons.value.length !== 0) {
                bottomSettingButtons.value.push(bottomButtonSep);
              }
              bottomSettingButtons.value.push(shareButton);
            }
            if (showManage.value) {
              if (bottomSettingButtons.value.length !== 0) {
                bottomSettingButtons.value.push(bottomButtonSep);
              }
              bottomSettingButtons.value.push(manageButton);
            }
            //只要有一个按钮，就将showBottomSetting设置为true
            showBottomSetting.value = showCollection || showShare || showManage.value;
          } else {
            //未知异常
            showDialog({
              title: '扫码失败',
              allowHtml: true,
              message: "<div style='text-align: center;font-size: 16px;margin-top: 15px;'>请检查网络后重试！</div>" + "<div style='text-align: left;color: #42b983; margin-top: 20px;font-size: 12px;'>*如果网络没问题，仍然不能访问，可在App内部联系人工客服处理。</div>",
              confirmButtonText: '我知道了'
            });
          }
        } else {
          //未知异常
          showDialog({
            title: '扫码失败',
            allowHtml: true,
            message: "<div style='text-align: center;font-size: 16px;margin-top: 15px;'>请检查网络后重试！</div>" + "<div style='text-align: left;color: #42b983; margin-top: 20px;font-size: 12px;'>*如果网络没问题，仍然不能访问，可在App内部联系人工客服处理。</div>",
            confirmButtonText: '我知道了'
          });
        }
      }).catch(() => {
        showDialog({
          title: '扫码失败',
          allowHtml: true,
          message: "<div style='text-align: center;font-size: 16px;margin-top: 15px;'>请检查网络后重试！</div>" + "<div style='text-align: left;color: #42b983; margin-top: 20px;font-size: 12px;'>*如果网络没问题，仍然不能访问，可在App内部联系人工客服处理。</div>",
          confirmButtonText: '我知道了'
        });
      });
    }
    return (_ctx, _cache) => {
      const _component_van_skeleton = _resolveComponent("van-skeleton");
      const _component_van_divider = _resolveComponent("van-divider");
      const _component_van_password_input = _resolveComponent("van-password-input");
      const _component_van_number_keyboard = _resolveComponent("van-number-keyboard");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_overlay = _resolveComponent("van-overlay");
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock(_Fragment, null, [querying.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_skeleton, {
        title: "",
        row: 15,
        style: {
          "margin-top": "15px"
        }
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [showContent.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bodyList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [item.type === 'title' && (item.style.styleTypeName === 'TitleStyleType.H1' || item.style.styleTypeName === 'TitleStyleType.H2' || item.style.styleTypeName === 'TitleStyleType.H3' || item.style.styleTypeName === 'TitleStyleType.H4' || item.style.styleTypeName === 'TitleStyleType.H5' || item.style.styleTypeName === 'TitleStyleType.H6') ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
          style: _normalizeStyle(createTitleStyle(item.style))
        }, _toDisplayString(_unref(Base64).decode(item.style.title)), 5)])])) : item.type === 'body' && item.style.styleTypeName === 'TextStyleType.normal' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
          style: _normalizeStyle(createNormalBodyStyle(item.style))
        }, _toDisplayString(_unref(Base64).decode(item.style.text)), 5)])])) : item.type === 'body' && item.style.styleTypeName === 'TextStyleType.cb' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
          style: _normalizeStyle(createCbBodyStyle(item.style))
        }, [_createElementVNode("div", {
          style: _normalizeStyle(createNormalBodyStyle(item.style))
        }, _toDisplayString(_unref(Base64).decode(item.style.text)), 5)], 4)])])) : item.type === 'imageTxt' && item.style.styleTypeName === 'ImageTxtStyleType.onlyOne' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", {
          style: _normalizeStyle(createOneImageContainerStyle(item.style.images[0]))
        }, [_withDirectives(_createElementVNode("img", {
          onClick: $event => imageOnClick(item.style.images.map(imageTxtItem => imageTxtItem.url), 0),
          alt: _unref(Base64).decode(item.style.images[0].text),
          style: _normalizeStyle(createOneImageStyle(item.style.images[0]))
        }, null, 12, _hoisted_11), [[_directive_lazy, reformatImageUrl(item.style.images[0].url)]]), _createElementVNode("div", {
          style: _normalizeStyle(createNormalBodyStyle(item.style.images[0]))
        }, _toDisplayString(_unref(Base64).decode(item.style.images[0].text)), 5)], 4)])) : item.type === 'imageTxt' && item.style.styleTypeName === 'ImageTxtStyleType.sixGrid' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.style.images, (imageItem, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_withDirectives(_createElementVNode("img", {
            height: computeSixImageSize(),
            width: computeSixImageSize(),
            alt: _unref(Base64).decode(imageItem.text),
            class: "six-img-item",
            onClick: $event => imageOnClick(item.style.images.map(imageTxtItem => imageTxtItem.url), index)
          }, null, 8, _hoisted_15), [[_directive_lazy, reformatImageUrl(imageItem.url)]]), _createElementVNode("div", {
            style: _normalizeStyle(createNormalBodyStyle(imageItem))
          }, _toDisplayString(_unref(Base64).decode(imageItem.text)), 5)]);
        }), 128))])])])) : item.type === 'contactInfo' && item.style.styleTypeName === 'ContactInfoStyleType.normal' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(_unref(Base64).decode(item.style.title)), 1), _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(Base64).decode(item.style.subtitle)), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.style.phoneList, (phone, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_createElementVNode("div", {
            class: "contact-info-item",
            onClick: $event => callPhone(phone)
          }, [_hoisted_22, _createElementVNode("span", null, _toDisplayString(phone), 1)], 8, _hoisted_21)]);
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.style.emailList, (email, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_createElementVNode("div", {
            class: "contact-info-item",
            onClick: $event => sendEmail(email)
          }, [_hoisted_24, _createElementVNode("span", null, _toDisplayString(email), 1)], 8, _hoisted_23)]);
        }), 128))])])])) : item.type === 'time' && item.style.styleTypeName === 'TimeStyleType.countdown' ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(_unref(Base64).decode(item.style.title)), 1), _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(Base64).decode(item.style.subtitle)), 1), item.style.title !== '' || item.style.subtitle !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createVNode(_component_van_divider, {
          style: {
            "background-color": "rgb(169, 169, 169, 0.1)"
          }
        })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(showCountDownDays(item.style.endDate)), 1), _hoisted_33])])])])) : _createCommentVNode("", true)]);
      }), 128)), showBottomSetting.value ? (_openBlock(), _createElementBlock("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bottomSettingButtons.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [item === collectionButton ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "bottom-setting-button",
          onClick: _cache[0] || (_cache[0] = $event => collectionButtonOnClicked())
        }, _hoisted_37)) : item === shareButton ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "bottom-setting-button",
          onClick: _cache[1] || (_cache[1] = $event => shareButtonOnClicked())
        }, _hoisted_40)) : item === manageButton ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "bottom-setting-button",
          onClick: _cache[2] || (_cache[2] = $event => manageButtonOnClicked())
        }, _hoisted_43)) : item === bottomButtonSep ? (_openBlock(), _createElementBlock("div", _hoisted_44)) : _createCommentVNode("", true)]);
      }), 128))])) : _createCommentVNode("", true), !_unref(createdByVip) ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_hoisted_46, _createElementVNode("div", null, [_createElementVNode("span", {
        style: {
          "color": "#1777FF"
        },
        onClick: _cache[3] || (_cache[3] = $event => goDownloadApp())
      }, "二维码和条形码生成器"), _createTextVNode(" 提供技术支持 "), _hoisted_47])])) : _createCommentVNode("", true), !showManage.value ? (_openBlock(), _createElementBlock("div", _hoisted_48, [_createElementVNode("span", {
        onClick: _cache[4] || (_cache[4] = $event => report())
      }, "投诉")])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createVNode(_component_van_password_input, {
        value: inputPwd.value,
        info: "请输入4位数字密码",
        "error-info": errorInfo.value,
        length: 4,
        focused: showKeyboard.value,
        onFocus: _cache[5] || (_cache[5] = $event => showKeyboard.value = true)
      }, null, 8, ["value", "error-info", "focused"])]), _createVNode(_component_van_number_keyboard, {
        modelValue: inputPwd.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => inputPwd.value = $event),
        show: showKeyboard.value,
        onBlur: _cache[7] || (_cache[7] = $event => showKeyboard.value = false)
      }, null, 8, ["modelValue", "show"])])), _createVNode(_component_van_popup, {
        show: showManageContentDialog.value,
        "onUpdate:show": _cache[9] || (_cache[9] = $event => showManageContentDialog.value = $event),
        round: "",
        position: "bottom",
        closeable: "",
        style: {
          height: '35%'
        }
      }, {
        default: _withCtx(() => [_hoisted_51, _createElementVNode("div", {
          class: "manage-warn-container",
          onClick: _cache[8] || (_cache[8] = $event => fromManageReport())
        }, _hoisted_54), _hoisted_55, _hoisted_56]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: showCollectionGuide.value,
        "onUpdate:show": _cache[11] || (_cache[11] = $event => showCollectionGuide.value = $event),
        style: {
          "background": "none"
        }
      }, {
        default: _withCtx(() => [_hoisted_57, _createVNode(_component_van_button, {
          type: "primary",
          size: "normal",
          round: "",
          color: "#ffffff",
          plain: "",
          style: {
            "background": "none",
            "margin-top": "60px",
            "padding-left": "50px",
            "padding-right": "50px",
            "font-size": "20px"
          },
          onClick: _cache[10] || (_cache[10] = $event => dismissCollectionGuide())
        }, {
          default: _withCtx(() => [_createTextVNode(" 我知道了 ")]),
          _: 1
        })]),
        _: 1
      }, 8, ["show"])])), _createVNode(_component_van_overlay, {
        show: showMockAd.value,
        onClick: _cache[14] || (_cache[14] = $event => dismissMockAd())
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createVNode(_component_van_button, {
          round: "",
          size: "normal",
          onClick: _cache[12] || (_cache[12] = $event => dismissMockAd())
        }, {
          default: _withCtx(() => [_createTextVNode(" 关闭广告 ")]),
          _: 1
        }), _hoisted_60]), _createElementVNode("div", _hoisted_61, [_hoisted_62, _hoisted_63, _hoisted_64, _createVNode(_component_van_button, {
          onClick: _cache[13] || (_cache[13] = $event => goSearchApp()),
          round: "",
          size: "normal",
          color: "linear-gradient(to right, #ff6034, #ee0a24)",
          style: {
            "margin-top": "5vh",
            "margin-left": "15px",
            "margin-right": "15px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(" 复制App名字，去应用市场搜索 ")]),
          _: 1
        })])])]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};